'use client'

import { LinkInline } from '@cleanlab/design-system/components'
import { IconCheckCircleFilled } from '@cleanlab/design-system/icons'
import { useRouter } from 'next/navigation'
import { useEffect } from 'react'

import { useMyself, useResendVerificationEmail } from '@/api/users'

function ConfirmEmail() {
  const { data: userData } = useMyself({
    refetchInterval: 5000, // Refetch every 5 seconds
    refetchIntervalInBackground: false, // Only refetch when tab is focused
  })
  const router = useRouter()
  const email = userData?.email
  const { mutate: resendVerificationEmail } = useResendVerificationEmail()

  useEffect(() => {
    if (userData?.email_verified) {
      router.push('/account')
    }
  }, [userData, router])

  return (
    <div className="flex flex-col gap-5">
      <div className="flex flex-col gap-1">
        <h1 className="type-body-100 text-text-primary">Activate your free trial</h1>
        <p className="type-body-200-medium">
          You’re almost there. Please confirm your email address to finish the activation process.
        </p>
      </div>
      <div className="flex flex-col gap-4">
        <div className="flex w-full flex-col gap-3 rounded-2 border border-border-1 bg-surface-0 p-6">
          <div className="flex items-center gap-3">
            <IconCheckCircleFilled size={16} className="text-green-600" />
            <span className="type-body-200-medium text-green-600">
              Check your email to start your free trial
            </span>
          </div>
          <div className="flex flex-col gap-2">
            <p className="type-body-200 text-text-faint">
              Click on the link in the email we sent to {email ?? 'you'} to verify your email.
            </p>
            <p className="type-body-200 text-text-faint">
              <LinkInline href="https://cleanlab.ai/sales/" target="_blank">
                Book a session
              </LinkInline>{' '}
              with a Cleanlab AI expert to make the most out of your free trial.
            </p>
          </div>
        </div>
        <p className="type-body-100 text-text-faint">
          Still can&rsquo;t find the email?{' '}
          <LinkInline
            onClick={() => {
              resendVerificationEmail({})
            }}
          >
            Click here
          </LinkInline>{' '}
          to resend the email or{' '}
          <LinkInline href="mailto:support@cleanlab.ai">contact us</LinkInline> for support.
        </p>
      </div>
    </div>
  )
}

export default ConfirmEmail
